let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jdGBj")).then(() => parcelRequire('ezgn6'));